var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            showInner: false
        };
        _this.toggleInner = function () {
            var showInner = _this.state.showInner;
            _this.setState({
                showInner: !showInner
            });
        };
        return _this;
    }
    default_1.prototype.componentDidMount = function () {
        this.props.open && this.setState({
            showInner: true
        });
    };
    default_1.prototype.render = function () {
        var _a = this.props, headTitle = _a.headTitle, content = _a.content;
        var showInner = this.state.showInner;
        var itemCls = showInner ? ' selected' : '';
        return (_jsxs("div", __assign({ className: "item".concat(itemCls) }, { children: [_jsxs("div", __assign({ className: 'head', onClick: this.toggleInner }, { children: [_jsx("div", __assign({ className: 'title' }, { children: headTitle })), _jsx("div", { className: 'expand' })] })), showInner && _jsx("div", __assign({ className: 'inner' }, { children: content }))] })));
    };
    default_1.propTypes = {
        headTitle: PropTypes.any.isRequired,
        content: PropTypes.any.isRequired,
        open: PropTypes.any
    };
    return default_1;
}(React.Component));
export default default_1;



// WEBPACK FOOTER //
// ./src/components/info/termsAndConditions/shared/RenderItem.jsx